import { useState } from 'react';

interface Props {
  src: string;
  title: string;
  duration?: string;
  poster?: string;
}

export function VideoEmbed({ src, title, duration, poster }: Props) {
  const [isPlaying, setIsPlaying] = useState(false);

  if (isPlaying) {
    return (
      <div className="my-5 overflow-hidden rounded-lg bg-black">
        <video src={src} controls autoPlay className="w-full" poster={poster}>
          <track kind="captions" />
        </video>
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={() => setIsPlaying(true)}
      className="my-5 flex w-full items-center justify-center gap-3 rounded-lg bg-gradient-to-br from-gray-900 to-gray-700 px-6 py-8 text-white shadow-sm hover:from-gray-800 hover:to-gray-600"
      aria-label={`Play video: ${title}`}
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-full border-2 border-white bg-white/15 text-lg">▶</div>
      <div className="text-left">
        <div className="text-sm font-medium">{title}</div>
        {duration && <div className="text-xs text-gray-300">{duration}</div>}
      </div>
    </button>
  );
}
